import { type RefObject, useMemo } from 'react';
import { useActiveReviewDrawer } from '#hooks/useActiveReviewDrawer.ts';
import { Loader } from '../Loader/index.tsx';
import { Review } from '../Review/index.tsx';
import { ReviewDrawer } from '../ReviewDrawer/index.tsx';
import { buildDependencyKey } from './helpers/buildDependencyKey.ts';
import { ReviewContainer, ReviewsContainer } from './styled.ts';
import { type ComponentProps } from './types.ts';

export const Component = ({ hasNextPage, items = [], lastItemRef, loading, mediaTypeId }: ComponentProps) => {
  const [activeReviewDrawer, setActiveReviewDrawer] = useActiveReviewDrawer();

  const memoReviews = useMemo(
    () => (
      <>
        {items.map((item, index) => {
          const containerProps: { ref?: RefObject<HTMLDivElement | null> } = {};

          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          if (lastItemRef && index === items.length - 1) {
            containerProps.ref = lastItemRef;
          }

          return (
            <ReviewContainer key={`${String(item.id)}-${String(index)}`} {...containerProps}>
              <Review preview setActiveReviewDrawer={setActiveReviewDrawer} {...item} />
            </ReviewContainer>
          );
        })}
      </>
    ),
    [mediaTypeId, buildDependencyKey(items)], // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <>
      {activeReviewDrawer ? (
        <ReviewDrawer id={activeReviewDrawer.id} setActiveReviewDrawer={setActiveReviewDrawer} />
      ) : undefined}
      <ReviewsContainer>
        {memoReviews}
        {hasNextPage && loading && <Loader sx={{ marginTop: theme => theme.spacing(4) }} />}
      </ReviewsContainer>
    </>
  );
};
